import type { RealtimeChannel } from '@supabase/supabase-js';

import { supabase } from '@/lib/supabase';

type Listener = () => void;

const listeners = new Set<Listener>();
let channel: RealtimeChannel | null = null;
let notifyTimer: number | undefined;

function notify() {
  window.clearTimeout(notifyTimer);
  notifyTimer = window.setTimeout(() => {
    for (const listener of listeners) listener();
  }, 150);
}

function ensureChannel() {
  if (channel) return;
  channel = supabase
    .channel('admin-prospects')
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'prospect_discovery_candidates' },
      notify,
    )
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'prospect_previews' },
      notify,
    )
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'prospect_outreach_templates' },
      notify,
    )
    .subscribe();
}

export function subscribeAdminProspectsRealtime(onChange: Listener) {
  listeners.add(onChange);
  ensureChannel();

  return () => {
    listeners.delete(onChange);
    if (listeners.size > 0) return;
    window.clearTimeout(notifyTimer);
    if (channel) {
      void supabase.removeChannel(channel);
      channel = null;
    }
  };
}
